// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"131":"0dbb34ee","343":"aac5c414","914":"2d3197b2"}[chunkId] + ".chunk.js";
};